/**
 * Extract phone_id from interaction details
 * Handles both Map and plain object formats
 * @param {Map|Object} details - Interaction details object
 * @returns {string|null} - The phone_id or null if not found
 */
export const getPhoneIdFromDetails = details => {
  if (!details) return null;
  // Handle Map format (from Mongoose)
  if (details instanceof Map) {
    return details.get('phone_id') || null;
  }
  // Handle plain object format
  if (typeof details === 'object' && details !== null) {
    // Try direct property access
    if (details.phone_id !== undefined && details.phone_id !== null) {
      return details.phone_id;
    }
    // Try accessing via get if it's a Map-like object
    if (typeof details.get === 'function') {
      return details.get('phone_id') || null;
    }
  }
  return null;
};

/**
 * Normalize phone ID to string for comparison
 * Handles empty strings, undefined, null, and NaN values
 * @param {string|number|null|undefined} phoneId - The phone ID to normalize
 * @returns {string|null} - Normalized phone ID or null if invalid
 */
export const normalizePhoneId = phoneId => {
  if (!phoneId) return null;
  const str = String(phoneId).trim();
  if (str === '' || str === 'undefined' || str === 'null' || str === 'NaN') return null;
  return str;
};

